<template>
  <div class="min-h-screen bg-[#f1f3ec] font-sans flex relative overflow-x-hidden">
    
    <!-- Backdrop for mobile sidebar -->
    <div v-if="showSidenav && isSidebarOpen" class="fixed inset-0 z-40 bg-black/50 lg:hidden transition-opacity" @click="isSidebarOpen = false"></div>
    <!-- Sidenav: Floating on both Mobile and Desktop -->
    <div v-if="showSidenav" class="fixed z-50 inset-y-0 py-4 transition-all duration-300 ease-in-out lg:left-0" :class="[isSidebarOpen ? 'left-0' : '-left-[22rem]', 'w-[17.5rem]']">
      <Sidenav @close-sidebar="isSidebarOpen = false" />
    </div>

    <!-- Main Content wrapper -->
    <main class="flex-1 flex flex-col min-w-0 min-h-screen transition-all duration-300" :class="showSidenav ? 'lg:ml-[18.5rem]' : ''">
      <!-- Top Navbar: Floating -->
      <Navbar v-if="showNavbar" class="relative z-40 mx-4 lg:mx-2 mt-4" @toggle-sidebar="isSidebarOpen = !isSidebarOpen" />

      <!-- Main Content Area -->
      <div class="flex-1 w-full px-4 lg:px-2 relative">
        <router-view />
      </div>

      <Footer v-show="showFooter" class="mt-auto px-4 pb-4" />
    </main>
  </div>
</template>

<script>
import Sidenav from "@/components/layout/Sidenav.vue";
import Navbar from "@/components/layout/Navbar.vue";
import Footer from "@/components/layout/Footer.vue";

export default {
  components: {
    Sidenav,
    Navbar,
    Footer
  },
  data() {
    return {
      isSidebarOpen: false
    };
  },
  computed: {
    showSidenav() {
      return !this.$route.meta.hideLayout;
    },
    showNavbar() {
      return !this.$route.meta.hideLayout;
    },
    showFooter() {
      return !this.$route.meta.hideLayout;
    }
  },
  watch: {
    $route() {
      // Close sidebar on mobile when navigating
      if (window.innerWidth < 1024) {
        this.isSidebarOpen = false;
      }
    }
  }
};
</script>

<style>
body {
  background-color: #f1f3ec !important;
}
</style>
